import {locationContainer, RenderingServices, utils} from '@wallaby-ui/core';

import {WallabyCoreSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';

// add default tab
const SELECTED_TABS = {};

interface OwnProps {
  dateOnly?: boolean;
  queryParameters?: {selectedTabs?: string};
}

type Params = TemplatedCellRendererParams<
  WallabyCoreSchema.components['schemas']['DocumentForEncounterDto']
> &
  OwnProps;

export interface BaseDocumentsListLinkFormatterParamsReturnValue {
  documentId: string | number;
  hospitalizationId?: string;
  searchParams?: {selectedTabs: string};
}

export function baseDocumentsListLinkFormatterParams(
  params: Params,
  services: RenderingServices = {}
): BaseDocumentsListLinkFormatterParamsReturnValue {
  const {routeParams, store} = services;
  const {data, queryParameters} = params;

  const storeQueryParameters = store
    ? store.getState()[locationContainer.LOCATION_REDUCER_STATE_ID].parameters
    : queryParameters;

  const ownQueryParameters =
    storeQueryParameters[locationContainer.GLOBAL_PARAMETERS_PATH];

  const searchParams = {
    ...ownQueryParameters,
    // default tab can be overridden by query parameters
    selectedTabs:
      ownQueryParameters?.selectedTabs || JSON.stringify(SELECTED_TABS),
  };

  const documentId = data.documentVersionId;
  const hospitalizationId = routeParams?.hospitalizationId;

  return {
    ...params,
    documentId,
    hospitalizationId,
    searchParams,
  };
}
